import { ChartOptions } from 'chart.js'

const formatTime = (seconds) => {
  let totalMinutes = Math.round(seconds / 60)

  let hours = Math.floor(totalMinutes / 60)
  let minutes = totalMinutes % 60

  let timeString = ''

  if (hours > 0) {
    timeString += hours + ' Hour'
    if (hours > 1) timeString += 's'
    timeString += ' '
  }

  if (minutes > 0) {
    timeString += minutes + ' Minute'
    if (minutes > 1) timeString += 's'
    timeString += ' '
  }

  return timeString.trim()
}

export const generateTimeChartOptions = (yScaleText: string, stepSize: number | null = null, max: number | null = null): ChartOptions => {
  return {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => {
            let label = context.dataset.label || ''
            if (label) {
              label += ': '
            }
            if (context.parsed.y !== null) {
              label += formatTime(context.parsed.y * 3600) // Convert back to seconds
            }
            return label
          },
        },
      },
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: yScaleText,
          font: {
            size: 14,
            family: 'Roboto',
          },
        },
        ticks: {
          stepSize: stepSize,
          callback: (value) => formatTime(value * 3600),
        },
        max: max,
      },
    },
  }
}

export const generateChartOptions = (yScaleText: string, stepSize: number | null = null, max: number | null = null): ChartOptions => {
  return {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: yScaleText,
          font: {
            size: 14,
            family: 'Roboto',
          },
        },
        ticks: {
          stepSize: stepSize,
        },
        max: max,
      },
    },
  }
}

export const getChartConfig = (backgroundColor: string, barThickness: number, hidden: boolean = true): any => {
  return {
    borderColor: '#191015',
    backgroundColor: backgroundColor,
    barThickness: barThickness,
    hidden: !hidden,
  }
}
